export const getAuthorizedRedirectPath = (
  allowedPaths: string[],
  defaultFallback: string = '/home',
): string => {
  if (allowedPaths && allowedPaths.length > 0) {
    const validPath = allowedPaths.find(p => Boolean(p));
    if (validPath) return validPath;
  }
  return defaultFallback;
};

export default getAuthorizedRedirectPath;
